module.exports = __webpack_public_path__ + "static/media/police_officer_small.444c1095.jpg";